(function migratorControllerDefinition() {
    'use strict';

    angular.module('Migrator')
        .controller('MigratorFindController', [
            '$scope', 'config', '$state', '$translate', 'errorsExtend', 'migratorService',
            function migratorFindController($scope, config, $state, $translate, errors, migratorService) {
                $scope.load = function () {

                    $scope.find =
                        {
                            description: '',
                            batch:'',
                            id: null,
                            showNoData: false
                        };

                    $scope.data = {
                        currentPage: 1,
                        totalItems: 0,
                        itemsPerPage: 15,
                        from: 0
                    };

                    $translate(['PaginationNext', 'PaginationPrev'])
                        .then(function (translated) {
                            $scope.paginatorTranslations = {
                                nextText: translated.PaginationNext,
                                previousText: translated.PaginationPrev
                            };
                        });

                    $scope.items = [];

                    $scope.findAction();
                }

                $scope.view = function (migrator) {
                    $state.go('migrator-detail', { id: migrator.id });
                };

                $scope.findAction = function () {
                    
                    $scope.items = [];
                    $scope.find.showNoData = false;

                    return migratorService.get($scope.find.id, $scope.find.description, $scope.find.batch, $scope.data.currentPage, $scope.data.itemsPerPage).then(function getOk(result) {

                        $scope.items = result.value;
                        $scope.data.totalItems = result.totalCount;
                        $scope.data.from = result.from;

                        if ($scope.items.length === 0)
                            $scope.find.showNoData = true;

                    }, function getError(error) { errors.showError(error); });
                };

                $scope.load();
            }
        ]);
})();